export function totalPrizePool(info) {
    var _a, _b;
    const fees = ((_b = (_a = info.entryFee) === null || _a === void 0 ? void 0 : _a.ada) !== null && _b !== void 0 ? _b : 0) * info.trackDetails.fieldSize;
    const prize = info.prizePool.reduce((sum, val) => {
        var _a, _b;
        return sum + ((_a = val.ada) !== null && _a !== void 0 ? _a : 0) + ((_b = val.percent) !== null && _b !== void 0 ? _b : 0) * fees;
    }, 0);
    return prize;
}
